import { useCurrentUserSuspenseQuery } from "@/api/queries/useCurrentUserSuspenseQuery"
import Documents from "@/pages/medewerkers/$userId/documents/Documents"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/profiel/dossier/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { data } = useCurrentUserSuspenseQuery()

  return <Documents userId={Number(data.data.userId)} />
}
